<template>
  <div class="detail-pembatalan" v-if="showPembatalan">
    <h3 class="section-title">
      <span>Alasan Pembatalan</span>
    </h3>

    <div class="pembatalan-card">
      <div class="pembatalan-header">
        <span class="pembatalan-label">
          Alasan Pembatalan
        </span>
      </div>
      <div class="pembatalan-body">
        <div class="pembatalan-content">
          "{{ alasanPembatalan || 'Tidak ada alasan yang diberikan' }}"
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'DetailPembatalan',
  props: {
    // Cancellation reason text
    alasanPembatalan: {
      type: String,
      default: null,
    },
    // Current status of the surat
    status: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    // Only show if status is Dibatalkan and reason exists
    const showPembatalan = computed(() => {
      return props.status === 'Dibatalkan' && props.alasanPembatalan && props.alasanPembatalan.trim() !== ''
    })

    return {
      showPembatalan,
    }
  },
})
</script>

<style lang="scss" scoped>
.detail-pembatalan {
  margin-bottom: 24px;

  .section-title {
    margin-bottom: 16px;
  }

  .pembatalan-card {
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    border: 1px solid #d4d4ff;
    background-color: #EFEFFF;

    .pembatalan-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      flex-wrap: wrap;
      gap: 8px;

      .pembatalan-label {
        font-weight: 600;
        font-size: 14px;
        color: #1e2a3b;
        display: flex;
        align-items: center;
        gap: 6px;
      }
    }

    .pembatalan-body {
      background-color: #ffffff;
      padding: 4px 8px;
      font-size: 16px;
      font-weight: 600;
      color: #1e2a3b;
    }

    .pembatalan-content {
      font-size: 14px;
      color: #262626;
      line-height: 1.6;
      font-style: italic;
    }
  }
}
</style>
